import {
  fetchRecipesSimilar,
  selectRecipesSimilar,
} from 'logic/recipesSimilar';

export const MealPlanSwaps = {
  bindings: {
    recipe: '<',
    selected: '<',
    voomeProductId: '<',
    onPreview: '&',
    onRemove: '&',
    onRevert: '&',
    onSwap: '&',
  },

  template: `
    <div class="meal-plan-swaps">
      <h2 class="meal-plan-swaps-loading d-flex justify-content-center align-items-center mb-0"
        ng-hide="$ctrl.similarRecipes.length > 0">
        <spinner is-loading="true"></spinner>
        <span class="ml-2">Loading</span>
      </h2>
      <div class="clearfix"
        ng-show="$ctrl.similarRecipes.length > 0">
        <div class="col-2">
          <meal-plan-swap
            recipe="$ctrl.recipe"
            selected="$ctrl.selected"
            on-swap="$ctrl.onRevert()"
            on-preview="$ctrl.onPreview({ recipe: $ctrl.recipe })">
          </meal-plan-swap>
        </div>
        <div class="col-2"
          ng-repeat="recipe in $ctrl.similarRecipes track by $index">
          <meal-plan-swap
            recipe="recipe"
            selected="$ctrl.selected"
            on-swap="$ctrl.onSwap({ recipeContainerId: recipe.recipeContainerId })"
            on-preview="$ctrl.onPreview({ recipe: recipe })">
          </meal-plan-swap>
        </div>
        <div class="col-2">
          <div class="card-wrapper"
            ng-class="{ 'theme-border': !$ctrl.selected }"
            ng-click="$ctrl.onRemove()">
            <div class="card card-voome card-borderless card-leftovers d-flex align-items-center justify-content-center">
              <div class="card-block text-center px-2">
                <i class="fa fa-times mb-2"></i>
                <h6 class="text-black mb-0">
                  Remove this recipe from this week’s plan
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(
          this.mapState.bind(this),
          this.mapDispatch()
        );

        this.unsubscribe = connect(this);
        this.isLoading = true;

        if (this.recipe) {
          this.fetchRecipesSimilar(this.recipe.id, this.voomeProductId);
        }
      },

      $onDestroy() {
        this.unsubscribe();
      },

      mapState(state) {
        return {
          similarRecipes: selectRecipesSimilar(state, this.recipe.id),
        };
      },

      mapDispatch() {
        return { fetchRecipesSimilar };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanSwaps.js